export const routes = [
  {
    path: '',
    name: 'TeachersList',
    component: () => import('./pages/TeacherList.vue'),
    meta: {
      title: 'TeachersList',
      authorize: [],
    },
  },
];

export default routes;
